import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgKetoconazoleGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m19.02 19.16 2.64-2.21-1.45-.4-2.97 2.51.84-3.09-1.2-.32-1.65 6.08 1.19.33.35-1.27 1.17-.9 1.03 2.86 1.44.39-1.39-3.98Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "m27.66 8-15.5 4.16L8 27.66l11.35 11.35 15.51-4.15 4.15-15.51L27.66 8Zm6.18 25.84-14.11 3.78L9.39 27.29l3.79-14.11L27.29 9.4l10.33 10.33-3.78 14.11Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M23.79 26.22c-1.89 1.84-.54.53-2.43 2.37l.35.8-1.67.72.49 1.15 1.68-.72.34.77c2.64-.13.76-.04 3.39-.17.27-.91.24-1.91-.17-2.85a4.205 4.205 0 0 0-1.98-2.07Zm.38 3.76-.83.04-.49-1.13.56-.55.53-.51a2.892 2.892 0 0 1 .92 2.11l-.69.04ZM31.27 17.98a5.25 5.25 0 0 0-3.66.22 5.316 5.316 0 0 0-2.66 2.54c2.37 2.43.68.7 3.05 3.13l1.19-.52.92 2.15 1.15-.49-.92-2.16 1.15-.5c-.18-3.39-.06-.98-.22-4.37Zm-3.97 3.39-.78-.8c.42-.53.96-.95 1.58-1.22.52-.23 1.07-.34 1.63-.34.11 0 .22 0 .33.01l.03.62.04.87.05 1.04-1.91.83-.97-1.01Z",
    fill: "currentColor"
  }));
}

export { SvgKetoconazoleGlyph as default };
